module.exports = __webpack_public_path__ + "static/media/kappa.b2ea72b2.png";